import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CurrentUserService } from '../services/current-user.service';

export const roleGuard: CanActivateFn = async route => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  await currentUserService.load();

  const allowedRoles = (route.data?.['allowedRoles'] as string[] | undefined) ?? [];
  const blockedRoles = (route.data?.['blockedRoles'] as string[] | undefined) ?? [];
  const redirectTo = (route.data?.['redirectTo'] as string | undefined) ?? '';

  if (blockedRoles.length && currentUserService.hasAnyRole(blockedRoles)) {
    return router.parseUrl(redirectTo || '');
  }

  if (!allowedRoles.length) {
    return true;
  }

  const isAllowed = currentUserService.hasAnyRole(allowedRoles);
  if (isAllowed) {
    return true;
  }

  return router.parseUrl(redirectTo || '');
};